// MS UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Apartments dan Hotels',
  'site.currency': 'Mata wang',
  'site.language': 'Bahasa',
  'site.currencySelector': 'Pemilih mata wang',
  'site.languageSelector': 'Pemilih bahasa',
  'site.menu': 'Menu',
  'site.signIn': 'Daftar masuk',
  'site.signOut': 'Daftar keluar',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Buka menu',
  'site.footer.copyright': 'Hak cipta terpelihara.',
  'site.footer.manageBooking': 'Urus tempahan anda',
  'site.footer.terms': 'Terma & Syarat',
  'site.footer.privacy': 'Dasar Privasi',
  'site.trust.bestPrice': 'Jaminan Harga Terbaik',
  'site.trust.bestPriceDesc': 'Dapatkan kadar terbaik.',
  'site.trust.flexibleBooking': 'Tempahan Fleksibel',
  'site.trust.flexibleBookingDesc': 'Pertukaran & pembatalan mudah.',
  'site.trust.securePayments': 'Pembayaran Selamat',
  'site.trust.securePaymentsDesc': 'Checkout yang dipercayai & selamat.',
  'site.trust.localSupport': 'Sokongan Tempatan',
  'site.trust.localSupportDesc': 'Kami sentiasa sedia membantu.',
  'home.heroTitle': 'Cari penginapan sempurna anda',
  'home.inAustralia': 'di Australia',
  'home.heroSubtitle': 'Apartments dan hotels untuk setiap jenis penginapan',
  'home.errorLoading': 'Hartanah tidak dapat dimuatkan.',
  'home.noPropertiesTitle': 'Tiada hartanah tersedia buat masa ini.',
  'home.noPropertiesDescription': 'Cuba cari destinasi untuk teroka penginapan yang tersedia.',
  'home.exploreStays': 'Teroka penginapan',
  'home.property': 'hartanah',
  'home.property_one': 'hartanah',
  'home.property_other': 'hartanah',
  'home.properties': 'hartanah',
  'home.foundInAustralia': 'dijumpai di Australia',
  'search.errorLoading': 'Ketersediaan tidak dapat dimuatkan. Sila cuba lagi.',
  'search.noResults': 'Tiada hartanah yang sepadan dengan kriteria carian anda.',
  'search.mapFollow': 'Cari semasa saya gerakkan peta',
  'search.chooseLocationTitle': 'Pilih lokasi',
  'search.chooseLocationDescription': 'Pilih destinasi sebelum mencari penginapan yang tersedia.',
  'search.chooseDatesTitle': 'Pilih tarikh anda',
  'search.pastCheckIn': 'Daftar masuk tidak boleh pada masa lalu.',
  'search.checkOutAfterCheckIn': 'Daftar keluar mesti selepas daftar masuk.',
  'search.property': 'hartanah',
  'search.property_one': 'hartanah',
  'search.property_other': 'hartanah',
  'search.properties': 'hartanah',
  'search.found': 'dijumpai',
  'widget.where': 'Di mana',
  'widget.location': 'Lokasi',
  'widget.checkInOut': 'Daftar masuk / Daftar keluar',
  'widget.guests': 'Tetamu',
  'widget.rooms': 'Bilik',
  'widget.promoCode': 'Kod Promo',
  'widget.promoPlaceholderCompact': 'Tambah kod (pilihan)',
  'widget.promoPlaceholder': 'Pilihan',
  'widget.search': 'Cari',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'Dewasa',
  'widget.adults': 'Dewasa',
  'widget.child': 'Kanak-kanak',
  'widget.children': 'Kanak-kanak',
  'widget.decreaseAdults': 'Kurangkan dewasa',
  'widget.increaseAdults': 'Tambah dewasa',
  'widget.decreaseChildren': 'Kurangkan kanak-kanak',
  'widget.increaseChildren': 'Tambah kanak-kanak',
  'widget.room': 'Bilik',
  'widget.adultOption': '{count} Dewasa',
  'widget.adultOption_one': '{count} Dewasa',
  'widget.adultOption_other': '{count} Dewasa',
  'widget.childOption': '{count} Kanak-kanak',
  'widget.childOption_one': '{count} Kanak-kanak',
  'widget.childOption_other': '{count} Kanak-kanak',
  'widget.roomOption': '{count} Bilik',
  'widget.roomOption_one': '{count} Bilik',
  'widget.roomOption_other': '{count} Bilik',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'Lokasi tidak dapat dimuatkan. Sila cuba lagi.',
  'widget.searchAria': 'Cari ketersediaan',
  'widget.dateErrorRequired': 'Sila pilih tarikh daftar masuk dan daftar keluar.',
  'widget.dateErrorPast': 'Daftar masuk tidak boleh pada masa lalu.',
  'widget.dateErrorRange': 'Daftar keluar mesti selepas daftar masuk.',
  'widget.dateRange.placeholder': 'Pilih tarikh daftar masuk & daftar keluar',
  'widget.dateRange.selectCheckout': 'Pilih daftar keluar',
  'widget.dateRange.aria.checkIn': 'Daftar masuk',
  'widget.dateRange.aria.checkOut': 'Daftar keluar',
  'widget.dateRange.aria.picker': 'Pemilih julat tarikh daftar masuk / daftar keluar',
  'widget.dateRange.previousMonth': 'Bulan sebelumnya',
  'widget.dateRange.nextMonth': 'Bulan seterusnya',
  'widget.dateRange.selectCheckIn': 'Pilih tarikh daftar masuk',
  'widget.dateRange.selectCheckOut': 'Pilih tarikh daftar keluar',
  'widget.dateRange.resetToday': 'Tetapkan semula ke Hari Ini',
  'widget.dateRange.done': 'Selesai',
  'property.heroAlt': 'Hartanah utama',
  'property.fallbackName': 'Hartanah terpilih oleh {site}',
  'property.chooseRoom': 'Pilih bilik anda',
  'property.filterBy': 'Tapis mengikut:',
  'property.filterAll': 'Semua Bilik',
  'property.filterStudios': 'Studio',
  'property.filter1Bed': '1 Bilik Tidur',
  'property.filter2Bed': '2 Bilik Tidur',
  'property.filterApartments': 'Apartments',
  'property.sortBy': 'Susun mengikut:',
  'property.sortRecommended': 'Disyorkan',
  'property.sortPriceLow': 'Harga: Rendah ke Tinggi',
  'property.sortPriceHigh': 'Harga: Tinggi ke Rendah',
  'property.errorLoading': 'Ketersediaan tidak dapat dimuatkan. Sila cuba lagi.',
  'property.noRooms': 'Tiada bilik tersedia',
  'property.noRoomsDescription': 'Cuba tarikh atau kapasiti lain.',
  'property.totalForNights': 'Jumlah untuk {nights} malam',
  'property.perNight': 'setiap malam',
  'property.night': 'malam',
  'property.night_one': 'malam',
  'property.night_other': 'malam',
  'property.nights': 'malam',
  'property.freeCancellation': 'Pembatalan percuma',
  'property.selectRoom': 'Pilih bilik',
  'property.selected': 'Dipilih',
  'property.continue': 'Teruskan',
  'property.previousPhoto': 'Gambar sebelumnya',
  'property.nextPhoto': 'Gambar seterusnya',
  'property.addToWishlist': 'Tambah ke senarai keinginan',
  'property.popularChoice': 'Pilihan popular',
  'property.showMore': 'Tunjuk lebih',
  'property.showLess': 'Tunjuk kurang',
  'property.maxOccupancy': 'Kapasiti Maksimum:',
  'property.size': 'Saiz:',
  'property.bedType': 'Jenis Katil:',
  'property.roomAmenities': 'Kemudahan Bilik',
  'property.showMoreAmenities': '+{count} lagi',
  'property.guests': 'Tetamu',
  'property.adults': 'Dewasa',
  'property.children': 'Kanak-kanak',
  'property.onlyRoomsLeft': 'Hanya {count} bilik lagi',
  'property.onlyRoomsLeft_one': 'Hanya {count} bilik lagi',
  'property.onlyRoomsLeft_other': 'Hanya {count} bilik lagi',
  'property.lastBookedMinutes': 'Tempahan terakhir {count} minit lalu',
  'property.lastBookedMinutes_one': 'Tempahan terakhir {count} minit lalu',
  'property.lastBookedMinutes_other': 'Tempahan terakhir {count} minit lalu',
  'property.lastBookedHours': 'Tempahan terakhir {count} jam lalu',
  'property.lastBookedHours_one': 'Tempahan terakhir {count} jam lalu',
  'property.lastBookedHours_other': 'Tempahan terakhir {count} jam lalu',
  'property.lastBookedDays': 'Tempahan terakhir {count} hari lalu',
  'property.lastBookedDays_one': 'Tempahan terakhir {count} hari lalu',
  'property.lastBookedDays_other': 'Tempahan terakhir {count} hari lalu',
  'property.checkInTime': 'Daftar masuk {time}',
  'property.checkOutTime': 'Daftar keluar {time}',
  'property.compare': 'Bandingkan',
  'property.taxesIncluded': 'setiap malam termasuk cukai & yuran',
  'property.chooseRate': 'Pilih kadar anda',
  'property.yourSelection': 'Pilihan anda',
  'property.aboutRoom': 'Mengenai bilik ini',
  'property.roomDetails': 'Butiran bilik',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Kembali ke bilik',
  'property.standardRate': 'Kadar Standard',
  'property.noPromotion': 'Tiada promosi tersedia untuk kadar ini.',
  'property.youSave': 'Anda jimat ({percent}% diskaun) - {amount}',
  'property.inclusions': 'Termasuk:',
  'property.viewAllPhotos': 'Lihat semua gambar',
  'property.seeOnMap': 'Lihat pada peta',
  'room.perNight': 'malam',
  'room.sleeps': 'Muat',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'tersedia',
  'room.select': 'Pilih',
  'room.selected': 'Dipilih',
  'card.viewAvailability': 'Lihat ketersediaan',
  'card.from': 'Dari',
  'card.night': 'malam',
  'card.checkAvailability': 'Semak Ketersediaan',
  'card.saveToFavourites': 'Simpan ke kegemaran',
  'card.ratingExcellent': 'Cemerlang',
  'card.ratingVeryGood': 'Sangat baik',
  'card.ratingGood': 'Baik',
  'card.ratingGuest': 'Penilaian tetamu',
  'guest.stepChooseRoom': 'Pilih Bilik',
  'guest.stepGuestDetails': 'Butiran Tetamu',
  'guest.stepPayment': 'Pembayaran',
  'guest.stepConfirmation': 'Pengesahan',
  'guest.title': 'Masukkan Butiran Tetamu',
  'guest.subtitle': 'Sila berikan maklumat anda.',
  'guest.firstName': 'Nama pertama',
  'guest.lastName': 'Nama keluarga',
  'guest.email': 'Emel',
  'guest.emailHint': 'Pengesahan tempahan akan dihantar ke emel ini.',
  'guest.country': 'Negara',
  'guest.selectCountry': 'Pilih negara',
  'guest.searchCountry': 'Cari negara…',
  'guest.loadingCountries': 'Memuatkan negara…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Poskod',
  'guest.phone': 'Nombor telefon',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Masukkan nombor telefon',
  'guest.address': 'Alamat',
  'guest.city': 'Bandar',
  'guest.specialRequests': 'Permintaan khas (pilihan)',
  'guest.specialRequestsPlaceholder': 'Sebarang permintaan khas?',
  'guest.termsPrefix': 'Dengan menyelesaikan tempahan ini, saya bersetuju dengan',
  'guest.terms': 'Terma & Syarat',
  'guest.termsAnd': 'dan',
  'guest.privacy': 'Dasar Privasi',
  'guest.termsSuffix': ', dan saya menerima syarat tempahan.',
  'guest.marketingOptOut': 'Saya tidak mahu menerima mesej pemasaran.',
  'guest.cardVerify':
    'Pengesahan kad 1 {currency} sementara akan diletakkan. Anda tidak akan dikenakan bayaran sekarang.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'Pembayaran akan dikutip di hartanah.',
  'guest.noRoomsSelected': 'Tiada bilik dipilih.',
  'guest.noPropertySelected': 'Tiada hartanah dipilih.',
  'guest.paymentStillLoading': 'Pilihan pembayaran masih dimuatkan. Sila cuba sebentar lagi.',
  'guest.submitProcessing': 'Memproses…',
  'guest.submitVerifyCard': 'Sahkan kad dan sahkan tempahan',
  'guest.submitConfirm': 'Sahkan tempahan',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Pembayaran',
  'payment.method': 'Kaedah pembayaran',
  'payment.cardDetailsHint':
    'Masukkan butiran kad anda dengan selamat di bawah. Butiran kad anda ditokenkan dan tidak pernah menyentuh pelayan kami.',
  'payment.loadingForm': 'Memuatkan borang pembayaran…',
  'payment.formUnavailable': 'Borang pembayaran tidak tersedia.',
  'payment.acceptTerms': 'Saya menerima terma dan syarat serta dasar pembatalan.',
  'payment.payNow': 'Bayar sekarang',
  'payment.processing': 'Memproses…',
  'payment.noRoomsSelected': 'Tiada bilik dipilih.',
  'payment.redirecting': 'Mengarahkan ke halaman pembayaran selamat…',
  'payment.notConfigured': 'Quickstream tidak dikonfigurasi untuk hartanah ini.',
  'payment.noScript':
    'Perkhidmatan pembayaran Quickstream tidak dapat dimuatkan. Sila muat semula halaman.',
  'payment.formNotLoaded': 'Borang pembayaran tidak dimuatkan. Sila muat semula halaman.',
  'payment.cardDetails': 'Pembayaran gagal. Sila semak butiran kad anda.',
  'payment.tokenizationFailed': 'Tokenisasi kad gagal. Sila cuba lagi.',
  'payment.failed': 'Pembayaran gagal.',
  'payment.statusResult': 'Status pembayaran: {status}. Sila cuba lagi.',
  'confirmation.loading': 'Memuatkan tempahan anda…',
  'confirmation.notFound': 'Tempahan tidak dijumpai. Semak rujukan tempahan anda dan cuba lagi.',
  'confirmation.errorGeneric': 'Tempahan anda tidak dapat disahkan. Sila hubungi sokongan.',
  'confirmation.errorLoadDetails': 'Tidak dapat memuatkan butiran tempahan.',
  'confirmation.couldNotComplete': 'Kami tidak dapat melengkapkan pembayaran anda',
  'confirmation.startNew': 'Mulakan tempahan baharu',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': 'Sesi pembayaran tidak dijumpai. Sila hubungi sokongan.',
  'confirmation.paymentStateInvalid':
    'Pembayaran tidak dalam keadaan sah untuk dilengkapkan. Sila mulakan semula.',
  'confirmation.paymentFailedDeclined':
    'Pembayaran anda tidak dapat dilengkapkan. Sila semak butiran kad anda dan cuba lagi, atau gunakan kaedah pembayaran lain.',
  'confirmation.paymentTimeout': 'Pembayaran mengambil masa terlalu lama. Sila cuba lagi.',
  'confirmation.paymentGatewayUnavailable':
    'Sistem pembayaran tidak tersedia buat sementara. Sila cuba lagi sebentar lagi.',
  'confirmation.paymentUnknown': 'Pembayaran tidak dapat disahkan: {message}.',
  'confirmation.paymentGenericError':
    'Pembayaran tidak dapat disahkan. Sila cuba lagi atau hubungi sokongan.',
  'summary.title': 'Ringkasan Tempahan Anda',
  'summary.yourBooking': 'Ringkasan Tempahan Anda',
  'summary.noRoomsSelected': 'Tiada bilik dipilih lagi.',
  'summary.checkIn': 'DAFTAR MASUK',
  'summary.checkOut': 'DAFTAR KELUAR',
  'summary.lengthOfStay': 'Tempoh penginapan',
  'summary.guests': 'Tetamu',
  'summary.nights': '{nights} malam',
  'summary.nights_one': '{nights} malam',
  'summary.nights_other': '{nights} malam',
  'summary.totalForNights': 'Jumlah untuk {nights} malam',
  'summary.includingTaxes': 'Termasuk cukai & yuran',
  'summary.discount': 'Jimat {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'Tempahan disahkan!',
  'detail.received': 'Tempahan diterima',
  'detail.referenceIntro': 'Rujukan tempahan anda ialah',
  'detail.reservationId': 'Id tempahan:',
  'detail.processing':
    'Tempahan anda sedang diproses. Anda akan menerima emel pengesahan setelah pembayaran disahkan.',
  'detail.guest': 'Tetamu',
  'detail.rooms': 'Bilik',
  'detail.night': 'malam',
  'detail.nights': 'malam',
  'detail.adult': 'dewasa',
  'detail.adults': 'dewasa',
  'detail.child': 'kanak-kanak',
  'detail.infant': 'bayi',
  'detail.priceBreakdown': 'Perincian harga',
  'detail.subtotal': 'Jumlah kecil',
  'detail.taxes': 'Cukai',
  'detail.fees': 'Yuran',
  'detail.discounts': 'Diskaun',
  'detail.surcharge': 'Surcaj kad',
  'detail.grandTotal': 'Jumlah keseluruhan',
  'priceBreakdown.roomSubtotal': 'Jumlah kecil bilik',
  'priceBreakdown.total': 'Jumlah',
  'detail.deposit': 'Deposit',
  'detail.depositDueBy': 'dijelaskan menjelang',
  'detail.arrival': 'ketibaan',
  'detail.specialRequests': 'Permintaan khas',
  'detail.backToHome': 'Kembali ke laman utama',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Cuba lagi',
  'shared.close': 'Tutup',
  'shared.back': 'Kembali',
  'shared.previous': 'Sebelumnya',
  'shared.next': 'Seterusnya',
  'validation.firstNameRequired': 'Nama pertama diperlukan',
  'validation.lastNameRequired': 'Nama keluarga diperlukan',
  'validation.emailRequired': 'Emel sah diperlukan',
  'validation.phoneRequired': 'Nombor telefon diperlukan',
  'validation.addressRequired': 'Alamat diperlukan',
  'validation.cityRequired': 'Bandar diperlukan',
  'validation.countryRequired': 'Negara diperlukan',
  'validation.postalCodeRequired': 'Poskod diperlukan',
  'error.pmsUnavailable':
    'Maaf, bilik ini tidak lagi tersedia untuk tarikh yang dipilih. Sila kembali dan pilih tarikh atau bilik lain.',
  'error.pmsSyncError':
    'Kami tidak dapat menghubungkan dengan sistem hartanah. Sila cuba lagi sebentar lagi.',
  'error.paymentNotConfigured':
    'Pembayaran tidak dikonfigurasi untuk hartanah ini. Sila pilih hartanah lain atau hubungi sokongan.',
  'error.paymentStartFailed':
    'Sesuatu yang tidak kena semasa memulakan pembayaran. Sila cuba lagi.',
  'error.bookingFailed': 'Tempahan gagal. Sila cuba lagi.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Tempah penginapan anda',
  'site.title.suffix': 'Apartments dan Hotels',
  'site.title.home': 'Laman Utama',
  'site.title.search': 'Cari',
  'site.title.property': 'Hartanah',
  'site.title.room': 'Bilik',
  'site.title.guestDetails': 'Butiran Tetamu',
  'site.title.payment': 'Pembayaran',
  'site.title.confirmation': 'Tempahan Disahkan',
  'site.title.bookingLookup': 'Cari tempahan anda',
  'site.title.bookingDetails': 'Butiran tempahan',
  'site.title.cancellation': 'Batalkan tempahan',
  'site.title.reservationDetail': 'Butiran tempahan',
  'site.title.signIn': 'Daftar masuk',
  'site.title.signUp': 'Daftar',
  'site.title.notFound': 'Halaman tidak dijumpai',
  'notFound.title': 'Halaman tidak dijumpai',
  'notFound.message': 'Halaman yang anda cari tidak wujud.',
  'notFound.backHome': 'Kembali ke laman utama',
  'home.heroAlt': 'Latar langit bandar Australia',
  'home.featuredProperties': 'Hartanah pilihan',
  'home.popularDestinations': 'Destinasi popular',
  'common.reviews': '{count} ulasan',
  'common.reviews_one': '{count} ulasan',
  'common.reviews_other': '{count} ulasan',
  'common.loading': 'Memuatkan',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'daripada',
  'common.select': 'Pilih…',
  'common.search': 'Cari…',
  'common.selectLocation': 'Pilih lokasi',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'Tiada pilihan tersedia',
  'common.code': 'Kod',
  'common.searchCode': 'Cari kod…',
  'filter.title': 'Tapis',
  'filter.price': 'Harga',
  'filter.priceMinimum': 'Minimum',
  'filter.priceMaximum': 'Maksimum',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'Jenis Hartanah',
  'filter.propertyType.hotel': 'Hotel',
  'filter.propertyType.apartment': 'Apartment',
  'filter.propertyType.resort': 'Resort',
  'filter.amenities': 'Kemudahan',
  'filter.amenity.pool': 'Kolam renang',
  'filter.amenity.parking': 'Tempat letak kereta',
  'filter.amenity.breakfast': 'Sarapan termasuk',
  'filter.rating': 'Penilaian',
  'filter.rating.any': 'Sebarang penilaian',
  'filter.rating.5': '5 bintang',
  'filter.rating.4': '4 bintang ke atas',
  'filter.rating.3': '3 bintang ke atas',
  'filter.more': 'Lagi',
  'filter.more.freeCancellation': 'Pembatalan percuma',
  'filter.more.payAtProperty': 'Bayar di hartanah',
  'filter.clear': 'Kosongkan',
  'filter.apply': 'Guna tapisan',
  'card.reviews_one': 'ulasan',
  'card.reviews_other': 'ulasan',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'Umur 0 - 12',
  'auth.orContinueWith': 'Atau teruskan dengan',
  'auth.signIn.title': 'Daftar masuk ke akaun anda',
  'auth.signIn.subtitle':
    'Selamat kembali! Daftar masuk untuk menguruskan tempahan anda, melihat penginapan dan menikmati tawaran eksklusif.',
  'auth.email': 'Emel',
  'auth.emailPlaceholder': 'Masukkan alamat emel anda',
  'auth.emailRequired': 'Emel diperlukan.',
  'auth.emailInvalid': 'Sila masukkan alamat emel yang sah.',
  'auth.password': 'Kata laluan',
  'auth.passwordPlaceholder': 'Masukkan kata laluan anda',
  'auth.createPasswordPlaceholder': 'Cipta kata laluan',
  'auth.passwordRequired': 'Kata laluan diperlukan.',
  'auth.passwordMinLength': 'Kata laluan mesti sekurang-kurangnya {min} aksara.',
  'auth.passwordPattern': 'Kata laluan mesti mengandungi huruf dan nombor.',
  'auth.passwordHint':
    'Gunakan sekurang-kurangnya {min} aksara dengan campuran huruf, nombor dan simbol.',
  'auth.showPassword': 'Tunjuk kata laluan',
  'auth.hidePassword': 'Sembunyikan kata laluan',
  'auth.keepSignedIn': 'Kekalkan saya log masuk',
  'auth.forgotPassword': 'Lupa kata laluan?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Daftar masuk',
  'auth.signingIn': 'Sedang mendaftar masuk...',
  'auth.signInError': 'Daftar masuk gagal. Sila cuba lagi.',
  'auth.googleError': 'Daftar masuk Google gagal.',
  'auth.noAccount': 'Belum ada akaun?',
  'auth.createAccount': 'Cipta akaun',
  'auth.signUp.title': 'Cipta akaun anda',
  'auth.signUp.subtitle':
    'Sertai {site} untuk menguruskan tempahan anda, menyimpan hartanah kegemaran dan menikmati tawaran eksklusif.',
  'auth.firstName': 'Nama pertama',
  'auth.firstNamePlaceholder': 'Masukkan nama pertama anda',
  'auth.firstNameRequired': 'Nama pertama diperlukan.',
  'auth.lastName': 'Nama keluarga',
  'auth.lastNamePlaceholder': 'Masukkan nama keluarga anda',
  'auth.lastNameRequired': 'Nama keluarga diperlukan.',
  'auth.mobile': 'Nombor mudah alih',
  'auth.mobilePlaceholder': 'Masukkan nombor mudah alih anda',
  'auth.dialingCode': 'Kod panggilan negara',
  'auth.mobileRequired': 'Nombor mudah alih diperlukan.',
  'auth.mobileInvalid': 'Sila masukkan nombor mudah alih yang sah.',
  'auth.confirmPassword': 'Sahkan kata laluan',
  'auth.confirmPasswordPlaceholder': 'Sahkan kata laluan anda',
  'auth.termsAgree': 'Saya bersetuju dengan',
  'auth.termsRequired': 'Anda mesti bersetuju dengan Terma & Syarat dan Dasar Privasi.',
  'auth.marketingConsent':
    'Saya ingin menerima tawaran eksklusif dan inspirasi perjalanan daripada {site}',
  'auth.signUpError': 'Tidak dapat mencipta akaun. Sila cuba lagi.',
  'auth.signUp': 'Daftar',
  'auth.creatingAccount': 'Mencipta akaun...',
  'auth.createAccountButton': 'Cipta akaun',
  'auth.alreadyHaveAccount': 'Sudah ada akaun?',
  'auth.passwordMismatch': 'Kata laluan tidak sepadan.',
  'pricing.title': 'Ringkasan harga',
  'pricing.noRoomsSelected': 'Tiada bilik dipilih. Sila kembali dan pilih bilik.',
  'pricing.backToAvailability': 'Kembali ke ketersediaan',
  'pricing.continue': 'Teruskan ke butiran tetamu',
  'property.youSavePercent': 'Anda jimat ({percent}% diskaun)',
  'property.includingTaxesFees': '(termasuk cukai & yuran)',
  'map.zoomIn': 'Zum masuk',
  'map.zoomOut': 'Zum keluar',
  'map.viewFullMap': 'Lihat dalam peta penuh',
  'booking.progress': 'Kemajuan tempahan',
  'reservationDetail.resetAria': 'Tetapkan semula status tempahan',
  'bookingLookup.title': 'Cari tempahan anda',
  'bookingLookup.description':
    'Masukkan rujukan tempahan dan emel anda untuk melihat, mengubah suai atau membatalkan tempahan anda.',
  'bookingLookup.bookingReference': 'Rujukan tempahan',
  'bookingLookup.placeholder': 'cth. SYD-260815-0001',
  'bookingLookup.lookingUp': 'Mencari…',
  'bookingLookup.findBooking': 'Cari tempahan',
  'bookingLookup.notFound':
    'Tempahan tidak dijumpai. Cuba BK-2026-001, alex.morgan@example.com dan Morgan.',
  'cancellation.title': 'Batalkan tempahan',
  'cancellation.property': 'Hartanah',
  'cancellation.details': 'Butiran pembatalan',
  'cancellation.penalty': 'Penalti pembatalan',
  'cancellation.refund': 'Jumlah bayaran balik',
  'cancellation.totalPaid': 'Jumlah dibayar:',
  'cancellation.reasonLabel': 'Sebab pembatalan (pilihan)',
  'cancellation.understand': 'Saya faham tindakan ini tidak boleh dibatalkan.',
  'cancellation.cancelledDemo':
    'Tempahan anda telah dibatalkan dalam demo UI ini. Jumlah bayaran balik: {{refundAmount}}.',
  'cancellation.confirm': 'Sahkan pembatalan',
  'cancellation.notFound': 'Tempahan tidak dijumpai.',
  'bookingDetails.title': 'Butiran tempahan',
  'bookingDetails.notFound': 'Tempahan tidak dijumpai.',
  'bookingDetails.checkIn': 'Daftar masuk:',
  'bookingDetails.checkOut': 'Daftar keluar:',
  'bookingDetails.rooms': 'Bilik',
  'bookingDetails.guest': 'Tetamu',
  'bookingDetails.freeCancellationUntil': 'Pembatalan percuma sehingga {date}',
  'bookingDetails.total': 'Jumlah:',
  'reservationDetail.loading': 'Memuatkan tempahan anda…',
  'reservationDetail.noReference': 'Tiada rujukan tempahan diberikan.',
  'reservationDetail.loadError': 'Tidak dapat memuatkan butiran tempahan.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'Memuatkan lokasi…',
  'common.couldNotLoadLocations': 'Tidak dapat memuatkan lokasi',
  'common.searchLocationPlaceholder': 'Cari negara, bandar atau hartanah',
  'common.collapse': 'Tutup',
  'common.expand': 'Kembangkan',
  'map.loadingGoogle': 'Memuatkan Google Map…',
  'map.errorGoogle': 'Gagal memuatkan Google Maps',
  'map.errorMap': 'Gagal memuatkan peta.',
  'map.greatLocation': 'Lokasi hebat',
  'home.trust.secureBooking': 'Tempahan Selamat',
  'home.trust.secureBookingDesc': 'Maklumat anda selamat bersama kami.',
  'home.trust.bestPrice': 'Jaminan Harga Terbaik',
  'home.trust.bestPriceDesc': 'Jumpa harga lebih rendah? Kami akan padankannya.',
  'home.trust.localSupport': 'Sokongan 24/7',
  'home.trust.localSupportDesc': 'Kami sentiasa sedia membantu.',
  'home.trust.flexibleBooking': 'Pilihan Fleksibel',
  'home.trust.flexibleBookingDesc': 'Pembatalan percuma untuk kadar terpilih.',
  'promotion.memberPromo': 'Promo Ahli',
  'promotion.save': 'Jimat',
  'property.memberRate': 'Kadar Ahli',
  'property.hideAmenities': 'Sembunyikan kemudahan',
  'property.showAllAmenities': 'Tunjukkan semua kemudahan',
  'property.chooseRatePromo':
    'Pilih kadar keutamaan anda - Kadar ahli menawarkan penjimatan eksklusif!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-{percent}% diskaun',
  'gallery.imageAlt': '{title} paparan {current} daripada {total}',
  'gallery.thumbnailAlt': 'Pergi ke paparan {current} daripada {total}',
  'gallery.previewAlt': 'Pratonton {title}',
  'detail.night_one': 'malam',
  'detail.night_other': 'malam',
  'detail.adult_one': 'dewasa',
  'detail.adult_other': 'dewasa',
  'detail.child_one': 'kanak-kanak',
  'detail.child_other': 'kanak-kanak',
  'detail.infant_one': 'bayi',
  'detail.infant_other': 'bayi',
} as const;
